const config = {
    defaultPath: '/',
    fontFamily: `'Public Sans', sans-serif`,
    container: true,
    mode: 'light'
};

export default config;
export const drawerWidth = 260;

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
